// Routes served without a signed-in session. One list, imported by both gates — App.js decides
// whether to render the authenticated tree, navigation/routes.js decides whether to redirect.
// They used to be two literals that had already drifted apart.
export const PUBLIC_ROUTES = [
  '/esign-doc',
  '/bank-account',
  '/create-password',
  '/success/signing',
  '/enrollment',
  '/pay',
  ...(process.env.NODE_ENV === 'development' ? ['/ui-kit'] : []),
]

// Exact match or a full path segment — NOT a bare startsWith, which would make '/pay' swallow
// the authenticated '/payments/daily-processing'.
export const isPublicRoute = (pathname) => {
  const path = pathname || ''
  return PUBLIC_ROUTES.some((route) => path === route || path.startsWith(`${route}/`))
}
